import React, { useContext, useState } from 'react'
import { useSelector } from 'react-redux'
import { formKeySelector } from '../selectors/formBuilder.selector'
import { FormLockModeContext } from '../context/FormLockModeContext'

interface FieldLockGroupRowProps {
	formName: string
	label: string
	displayFields: string[]
	formatValue?: (values: Record<string, string>) => string
	col: number
	hasRequired?: boolean
	onUnlock: () => void
}

function FieldLockGroupRow({
	formName,
	label,
	displayFields,
	formatValue,
	col,
	hasRequired,
	onUnlock,
}: FieldLockGroupRowProps) {
	const controlsState = useSelector(
		formKeySelector(formName, 'controlsState'),
	)

	const formLockContext = useContext(FormLockModeContext)
	const values: Record<string, string> = {}
	displayFields.forEach((fieldName) => {
		values[fieldName] = String(
			(controlsState?.[fieldName] as any)?.value ?? '',
		)
	})

	const displayValue = formatValue
		? formatValue(values)
		: displayFields
				.map((f) => values[f])
				.filter(Boolean)
				.join(' ')

	return (
		<div className={`form-box col-${col}`}>
			<div className="field-lock-row">
				<div className="field-lock-info">
					<span className="field-lock-label">
						{label}
						{hasRequired && <span className="required">*</span>}
					</span>
					<span className="field-lock-value">
						{displayValue || '—'}
					</span>
				</div>
				{!formLockContext.lockMode && (
					<input
						type="checkbox"
						className="field-lock-toggle"
						checked={true}
						onChange={onUnlock}
						aria-label={`Edit ${label}`}
					/>
				)}
			</div>
		</div>
	)
}

export default FieldLockGroupRow
